const APPLE_PAY_BUTTON_ID = "st-apple-pay";

export { APPLE_PAY_BUTTON_ID };
